// src/config/skills.js
export const skills = [
  "Next.js",
  "JavaScript",
  "TypeScript",
  "Swift",
  "Python",
  "Unity",
  "React",
  "Vue.js",
  "Node.js",
  "Express",
  "MongoDB",
  "SQL",
  "REST APIs",
  "Git",
  "Project Management",
  "PostgreSQL",
  "Prisma",
  "Tailwind CSS",
];
